import script from "./DocLibraryMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocLibraryMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DocLibraryMenu.vue?vue&type=style&index=0&id=593f960a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593f960a"]])

export default __exports__